import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { DashboardService } from '../../../services/dashboard.service';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { CountUp } from 'countup.js';
import { viewinvoiceproductLookupComponent } from '../../Lookup/viewinvoiceproduct-lookup/viewinvoiceproduct-lookup.component';
import { AdministratorService } from '../../../services/administrator.service';
import { PurchaseOrder } from '../../../model/common/common.model';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-home-dashboard',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.scss'],
  providers: [DatePipe]
})
export class HomeDashboardComponent implements OnInit, AfterViewInit {

  constructor(
    private route: Router,
    private dashboardService: DashboardService,
    private router: Router,
    public dialogService: DialogService,
    private administratorService: AdministratorService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.username = JSON.parse(localStorage.getItem('auth') || '{}')?.user?.firstName || 'User';
    this.todayDate = this.datePipe.transform(new Date(), 'dd MMM yyyy') ?? '';
    this.initChartOptions();
    document.title = 'Home';

    this.loadDashboard();
    this.getTopSellingProducts();
    this.getCompanyDetails();
    this.getRecentPOs();
  }

  loader = true;
  selectedPeriod = '12m';
  todayDate = '';

  periodOptions = [
    { label: 'Last 12 Months', value: '12m' },
    { label: 'Last 6 Months', value: '6m' },
    { label: 'This Year', value: 'year' }
  ];

  products: any;
  TopSellingProducts: any[] = [];
  RecentSalesProducts: any[] = [];
  RecentPO: any[] = [];
  selectedPOrder: PurchaseOrder[] = [];
  recentSalesChartData: any = { labels: [], datasets: [] };
  recentSalesChartOptions: any = {};
  recentPOChartData: any = { labels: [], datasets: [] };
  recentPOChartOptions: any = {};

  customer = 0;
  vendor = 0;
  salesperson = 0;
  invoice = 0;
  totalInvoiceInPeriod = 0;
  totalRevenue = 0;

  attentionBillsOverdue = 0;
  attentionBillsDueToday = 0;
  attentionInvoicesOverdue = 0;

  pendingPurchaseOrders = 0;
  pendingSalesOrders = 0;
  pendingPayments = 0;
  pendingMaterialRequests = 0;

  pendingActions = 0;
  attentionRequired = 0;
  openTaskCount = 0;
  openPhaseCount = 0;
  myTaskCount = 0;
  myPhaseCount = 0;

  username = '';
  companyName = '';

  onPeriodChange(): void {
    this.loadDashboard();
  }

  refreshData(): void {
    this.loadDashboard();
    this.getRecentPOs();
  }

  loadDashboard(): void {
    this.loader = true;
    const user: any = localStorage.getItem('username');

    forkJoin({
      homeData: this.dashboardService.getHomeDashboardData(),
      recentSales: this.dashboardService.getRecentSales(user, this.selectedPeriod),
      projectData: this.dashboardService.getProjectDashboardData(),
      myTasks: this.dashboardService.getMyTask(),
      myPhases: this.dashboardService.getMyPhases()
    }).subscribe({
      next: ({ homeData, recentSales, projectData, myTasks, myPhases }: any) => {
        this.customer = homeData?.totalActiveCustomers ?? 0;
        this.vendor = homeData?.totalActiveVendors ?? 0;
        this.salesperson = homeData?.totalActiveSalespeople ?? 0;
        this.invoice = homeData?.totalInvoicesLastMonth ?? 0;
        this.totalInvoiceInPeriod = homeData?.totalInvoices ?? 0;
        this.totalRevenue = homeData?.totalRevenue ?? 0;

        this.attentionBillsOverdue = homeData?.attentionBillsOverdue ?? 0;
        this.attentionBillsDueToday = homeData?.attentionBillsDueToday ?? 0;
        this.attentionInvoicesOverdue = homeData?.attentionInvoicesOverdue ?? 0;

        this.pendingPurchaseOrders = homeData?.pendingPurchaseOrders ?? 0;
        this.pendingSalesOrders = homeData?.pendingSalesOrders ?? 0;
        this.pendingPayments = homeData?.pendingPayments ?? 0;
        this.pendingMaterialRequests = homeData?.pendingMaterialRequests ?? 0;
        
        this.openTaskCount = projectData?.openTask ?? 0;
        this.openPhaseCount = projectData?.openPhases ?? 0;
        this.pendingActions = this.openTaskCount + this.openPhaseCount;

        this.myTaskCount = myTasks?.projectTasks?.length ?? 0;
        this.myPhaseCount = myPhases?.projectPhases?.length ?? 0;
        this.attentionRequired = this.myTaskCount + this.myPhaseCount;

        this.RecentSalesProducts = (recentSales || []).map((product: any) => ({
          ...product,
          productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg'
        }));

        this.buildRecentSalesChart();
        this.loader = false;
        setTimeout(() => this.animateNumbers(), 120);
      },
      error: (error: Error) => {
        console.error(error);
        this.loader = false;
      }
    });
  }

  getTopSellingProducts() {
    this.dashboardService.getTopSellingProducts(this.selectedPeriod).subscribe(
      (data: any) => {
        this.TopSellingProducts = data.map((product: any) => ({
          ...product,
          productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg'
        }));
      },
      (error: Error) => {
        console.error(error);
      }
    );
  }

  getRecentPOs() {
    this.dashboardService.getRecentPO().subscribe(
      (data: any) => {
        this.RecentPO = data.map((pos: any) => ({ ...pos }));
        this.buildRecentPOChart();
      },
      (error: Error) => {
        console.error(error);
      }
    );
  }

  editPOrder(data?: any): void {
    if (data) {
      this.route.navigate(['/home/createPurchaseOrder'], {
        queryParams: { purchaseOrderId: data },
        skipLocationChange: false
      });
    } else {
      this.route.navigate(['/home/createPurchaseOrder'], {
        queryParams: { purchaseOrderId: this.selectedPOrder[0].purchaseOrderId },
        skipLocationChange: false
      });
    }
  }

  viewProduct(data?: any) {
    const normalizedData = this.normalizeProductIdInPlace(data);
    this.dialogService.open(viewinvoiceproductLookupComponent, {
      header: 'Invoice Details',
      width: '70%',
      data: { salesOrderNumber: normalizedData.salesOrderNumber }
    });

    this.router.navigate([], {
      queryParams: { productData: JSON.stringify(normalizedData) },
      queryParamsHandling: 'merge',
      skipLocationChange: true
    });
  }

  private normalizeProductIdInPlace(invoice: any): any {
    if (invoice && invoice.productID) {
      invoice.productID = invoice.productID;
      delete invoice.productID;
    }
    return invoice;
  }

  ngAfterViewInit(): void {
    this.animateNumbers();
  }

  animateNumbers(): void {
    this.startCountUp('customerNumber', this.customer);
    this.startCountUp('vendorNumber', this.vendor);
    this.startCountUp('salespersonNumber', this.salesperson);
    this.startCountUp('invoiceNumber', this.invoice);
    this.startCountUp('pendingActionsNumber', this.pendingActions);
    this.startCountUp('attentionRequiredNumber', this.attentionRequired);
  }

  startCountUp(elementId: string, endValue: number): void {
    const options = {
      startVal: 0,
      duration: 4,
      useEasing: true,
      useGrouping: true
    };

    const numAnim = new CountUp(elementId, endValue, options);
    if (!numAnim.error) {
      numAnim.start();
    } else {
      console.error(numAnim.error);
    }
  }

  initChartOptions(): void {
    const axisStyle = {
      grid: { color: 'rgba(0,0,0,0.05)', drawBorder: false },
      ticks: {
        color: '#6b7280',
        font: { size: 10 }
      }
    };

    this.recentSalesChartOptions = {
      indexAxis: 'y' as const,
      responsive: true,
      maintainAspectRatio: false,
      animation: { duration: 1500, easing: 'easeOutQuart' },
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (ctx: any) => ` ₹${(ctx.raw || 0).toLocaleString('en-IN')}`
          }
        }
      },
      scales: {
        x: {
          ...axisStyle,
          ticks: {
            ...axisStyle.ticks,
            callback: (v: any) => `₹${Number(v).toLocaleString('en-IN')}`
          }
        },
        y: {
          ...axisStyle,
          grid: { display: false },
          ticks: { color: '#374151', font: { size: 11, weight: '600' } }
        }
      }
    };

    this.recentPOChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      animation: { duration: 1400, easing: 'easeOutBack' },
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (ctx: any) => ` ₹${(ctx.raw || 0).toLocaleString('en-IN')}`
          }
        }
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: { color: '#6b7280', maxRotation: 45, minRotation: 45, font: { size: 10 } }
        },
        y: {
          grid: { color: 'rgba(0,0,0,0.05)', drawBorder: false },
          ticks: {
            color: '#6b7280',
            font: { size: 10 },
            callback: (v: any) => `₹${Number(v).toLocaleString('en-IN')}`
          }
        }
      }
    };
  }

  buildRecentSalesChart(): void {
    const items = (this.RecentSalesProducts || []).slice(0, 8);
    this.recentSalesChartData = {
      labels: items.map((s: any) => (s.productDescription || 'Product').toString().slice(0, 18)),
      datasets: [{
        label: 'Unit Price',
        data: items.map((s: any) => Number(s.unitPrice || 0)),
        backgroundColor: items.map((_: any, i: number) => `hsl(${210 + (i * 18)}, 82%, 58%)`),
        borderRadius: 8,
        borderSkipped: false,
        barThickness: 14
      }]
    };
  }

  buildRecentPOChart(): void {
    const items = (this.RecentPO || []).slice(0, 8);
    this.recentPOChartData = {
      labels: items.map((p: any) => p.purchaseOrderNumber || 'PO'),
      datasets: [{
        label: 'PO Total',
        data: items.map((p: any) => Number(p.poTotal || 0)),
        backgroundColor: 'rgba(124, 58, 237, 0.75)',
        borderColor: '#7c3aed',
        borderWidth: 1.2,
        borderRadius: 10,
        fill: true,
        tension: 0.35
      }]
    };
  }

  getRevenueDisplay(): string {
    return `₹${this.totalRevenue.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          this.companyName = data[0].companyName;
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
